import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,CCol,
	CForm,CFormInput,CFormTextarea,CFormCheck,CFormSelect,CFormSwitch,
	CInputGroup,CInputGroupText,CButton,CFormLabel,
	CModal,CModalBody,CModalFooter,CModalHeader,
	CModalTitle,CCloseButton,
	CLink,
} from '@coreui/react';
import { isMobile } from "react-device-detect";
import CIcon from '@coreui/icons-react';
import { 
} from './index';
import { Konfirm } from '../helpers/onConfirm';
import { UFunc } from "../helpers/functions";

const pjson 	= require('../../package.json')
const MyDialognomorgigi = props => {
	const { 
		showDlg, toggleShow, dataSelectedArr, onKlikpilih, isUpdated,
		...rest 
	} = props;

	const uDispatch 				= useDispatch();
	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uDatainputArr 			= useSelector(state => state.gDatanomorgigiArr) || [];
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");

	const [uEfekview,setEfekview] 	= React.useState(false);
	const [uSelectedArr,setSelectedArr] = React.useState([]);

	//--DOM--/
	const uISCellphonemode			= window.outerWidth <= 425 || isMobile;
	const uISTabletmode				= window.outerWidth > 425 && window.outerWidth <= 768;
	//--END DOM--/

	const OCLUSAL_SHAPES = {
		//--RAHANG_ATAS--/
		molarUpper: (
		<g>
		<path d="M 15,25 C 15,15 25,15 50,15 C 75,15 85,15 85,25 C 85,50 85,75 85,75 C 85,85 75,85 50,85 C 25,85 15,85 15,75 Z" className="tooth-outline" />
		<path d="M 30,35 L 35,50 L 30,65 M 35,50 L 65,50 M 70,35 L 65,50 L 70,65" className="tooth-fissure" />
		</g>
		),//>
		premolarUpper: (
		<g>
		<path d="M 20,30 C 20,15 35,15 50,15 C 65,15 80,15 80,30 C 80,50 80,70 80,70 C 80,85 65,85 50,85 C 35,85 20,85 20,70 Z" className="tooth-outline" />
		<path d="M 30,50 L 70,50 M 50,30 L 50,70" className="tooth-fissure" />
		</g>
		),//>
		canineUpper: (
		<g>
		<path d="M 50,15 C 70,15 80,35 75,55 C 70,75 55,85 50,85 C 45,85 30,75 25,55 C 20,35 30,15 50,15 Z" className="tooth-outline" />
		<path d="M 50,15 L 50,50 M 25,55 L 50,50 M 75,55 L 50,50" className="tooth-fissure" />
		</g>
		),//>
		incisorUpper: (
		<g>
		<path d="M 15,35 C 15,25 30,25 50,25 C 70,25 85,25 85,35 C 85,55 75,65 50,65 C 25,65 15,55 15,35 Z" className="tooth-outline" />
		<path d="M 15,42 L 85,42" className="tooth-fissure" />
		</g>
		),//>

		//--RAHANG_BAWAH--/
		molarLower: (
		<g>
		<path d="M 15,25 C 15,15 25,15 50,15 C 75,15 85,15 85,25 C 85,50 85,75 85,75 C 85,85 75,85 50,85 C 25,85 15,85 15,75 Z" className="tooth-outline" />
		<path d="M 30,35 L 35,50 L 30,65 M 35,50 L 65,50 M 70,35 L 65,50 L 70,65" className="tooth-fissure" />
		</g>
		),//>
		premolarLower: (
		<g>
		<path d="M 20,30 C 20,15 35,15 50,15 C 65,15 80,15 80,30 C 80,50 80,70 80,70 C 80,85 65,85 50,85 C 35,85 20,85 20,70 Z" className="tooth-outline" />
		<path d="M 30,50 L 70,50 M 50,30 L 50,70" className="tooth-fissure" />
		</g>
		),//>
		canineLower: (
		<g>
		<path d="M 50,85 C 70,85 80,65 75,45 C 70,25 55,15 50,15 C 45,15 30,25 25,45 C 20,65 30,85 50,85 Z" className="tooth-outline" />
		<path d="M 50,85 L 50,50 M 25,45 L 50,50 M 75,45 L 50,50" className="tooth-fissure" />
		</g>
		),//>
		incisorLower: (
		<g>
		<path d="M 15,65 C 15,75 30,75 50,75 C 70,75 85,75 85,65 C 85,45 75,35 50,35 C 25,35 15,45 15,65 Z" className="tooth-outline" />
		<path d="M 15,58 L 85,58" className="tooth-fissure" />
		</g>
		)//>
	};
	const ADULT_UPPER = [
		{ id: "18", type: "molarUpper" }, { id: "17", type: "molarUpper" }, { id: "16", type: "molarUpper" },
		{ id: "15", type: "premolarUpper" }, { id: "14", type: "premolarUpper" }, { id: "13", type: "canineUpper" },
		{ id: "12", type: "incisorUpper" }, { id: "11", type: "incisorUpper" },
		{ id: "21", type: "incisorUpper" }, { id: "22", type: "incisorUpper" }, { id: "23", type: "canineUpper" },
		{ id: "24", type: "premolarUpper" }, { id: "25", type: "premolarUpper" },
		{ id: "26", type: "molarUpper" }, { id: "27", type: "molarUpper" }, { id: "28", type: "molarUpper" }
	];
	const CHILD_UPPER = [
		{ id: "55", type: "molarUpper" }, { id: "54", type: "molarUpper" }, { id: "53", type: "canineUpper" },
		{ id: "52", type: "incisorUpper" }, { id: "51", type: "incisorUpper" },
		{ id: "61", type: "incisorUpper" }, { id: "62", type: "incisorUpper" }, { id: "63", type: "canineUpper" },
		{ id: "64", type: "molarUpper" }, { id: "65", type: "molarUpper" }
	];
	const CHILD_LOWER = [
		{ id: "85", type: "molarLower" }, { id: "84", type: "molarLower" }, { id: "83", type: "canineLower" },
		{ id: "82", type: "incisorLower" }, { id: "81", type: "incisorLower" },
		{ id: "71", type: "incisorLower" }, { id: "72", type: "incisorLower" }, { id: "73", type: "canineLower" },
		{ id: "74", type: "molarLower" }, { id: "75", type: "molarLower" }
	];
	const ADULT_LOWER = [
		{ id: "48", type: "molarLower" }, { id: "47", type: "molarLower" }, { id: "46", type: "molarLower" },
		{ id: "45", type: "premolarLower" }, { id: "44", type: "premolarLower" }, { id: "43", type: "canineLower" },
		{ id: "42", type: "incisorLower" }, { id: "41", type: "incisorLower" },
		{ id: "31", type: "incisorLower" }, { id: "32", type: "incisorLower" }, { id: "33", type: "canineLower" },
		{ id: "34", type: "premolarLower" }, { id: "35", type: "premolarLower" },
		{ id: "36", type: "molarLower" }, { id: "37", type: "molarLower" }, { id: "38", type: "molarLower" }
	];

	const uJmlgigiall		= ADULT_UPPER.length + CHILD_UPPER.length +
		CHILD_LOWER.length + ADULT_LOWER.length;

	const uGigiMaxillaArr	= [...(ADULT_UPPER.map((vItems)=>vItems.id)),...(CHILD_UPPER.map((vItems)=>vItems.id))];
	const uGigiMandibulaArr	= [...(ADULT_LOWER.map((vItems)=>vItems.id)),...(CHILD_LOWER.map((vItems)=>vItems.id))];

	//console.log("(MyDialognomorgigi) uGigiMaxillaArr",uGigiMaxillaArr);

	//--HANDLE--/
	//--END HANDLE--/

	//--PROCEDURE--/
	//--END PROCEDURE--/

	//--CONTENT--/
	const renderTooth = (tooth, isSpacevertical = false) => {
		const isSelected = (uSelectedArr||[]).filter(vItems=>
			(vItems||"").toString()===(tooth.id || "").toString()).length > 0;

		return (
		<React.Fragment key={tooth.id}>
		<div className={"custom-tooth-box "+(isSelected ? 'is-selected' : '')}
			onClick={() => onKlikpilih(tooth.id)}>
			<svg viewBox="0 0 100 100" className="custom-tooth-svg">
				<g className={isSelected ? 'fill-selected' : 'fill-default'}>
				{OCLUSAL_SHAPES[tooth.type]}
				</g>
			</svg>
			<span className="tooth-lbl-num">{tooth.id}</span>
		</div>
		</React.Fragment>
		)//>
	}
	const contentStyling = () => {
		if(!showDlg) return (<></>)//>

		return (
		<style>{`
			.modern-odontogram-layout {
				background: #ffffff;
				padding: 8px;
				border-radius: 6px;
				border: 1px solid #cbd5e1;
				width: 100%;
				box-sizing: border-box;
			}

			.scroll-horizontal-guard {
				width: 100%;
				overflow-x: auto;
			}
			.odontogram-viewport-matrix {
				position: relative;
				min-width: 600px; /* Aman tanpa scroll untuk ukuran tablet */
				display: flex;
				flex-direction: column;
				gap: 2px;
			}
			.jaw-flex-strip {
				display: flex;
				width: 100%;
			}
			.grid-layout {
				display: grid;
				width: 100%;
				gap: 2px;
			}
			.columns-16 {
				grid-template-columns: repeat(16, 1fr);
			}
			.columns-10 {
				grid-template-columns: repeat(10, 1fr);
			}
			.child-row-center {
				max-width: 62.5%;
				margin: 0 auto;
			}
			.child-strip-spacing {
				margin: 1px 0;
			}

			/* BOX INTERAKSI & PADDING PADAT */
			.custom-tooth-box {
				display: flex;
				flex-direction: column;
				align-items: center;
				cursor: pointer;
				padding: 2px 1px;
				border-radius: 4px;
				z-index: 2;
				background-color: transparent;
				border: 1px solid transparent;/**/
				box-sizing: border-box;
			}
			.custom-tooth-box:hover {
				background-color: #f1f5f9;
				border: 1px solid #cbd5e1;
			}
			.custom-tooth-box.is-selected {
				background-color: #e6f2ff !important;
				border: 1px solid #007bff !important;
			}
			.custom-tooth-svg {
				display: block;
				width: 100%;
				height: auto;
			}

			/* DETAIL LINE VAKTOR */
			.tooth-outline {
				stroke-width: 5px;
				stroke-linejoin: round;
			}
			.tooth-fissure {
				stroke-width: 3.5px;
				stroke-linecap: round;
				stroke-linejoin: round;
			}

			/* COLOR STATES */
			.fill-default .tooth-outline {
				fill: #ffffff;
				stroke: #1e293b;
			}
			.fill-default .tooth-fissure {
				fill: none;
				stroke: #475569;
			}
			.fill-selected .tooth-outline {
				fill: #007bff;
				stroke: #004085;
			}
			.fill-selected .tooth-fissure {
				fill: none;
				stroke: #ffffff;
			}

			/* RATALAH NOMOR GIGI */
			.tooth-lbl-num {
				font-size: 11px;
				font-weight: bold;
				color: #334155;
				margin-top: 0;
				user-select: none;
				line-height: 1;
			}
			.custom-tooth-box.is-selected .tooth-lbl-num {
				color: #007bff;
			}

			/* GARIS SALIB */
			.center-axis-h {
				height: 2px;
				background: #AEAEAE;
				margin: 4px 0;
				width: 100%;
			}
			.center-axis-v {
				position: absolute;
				left: 49.9%;
				top: 0;
				bottom: 0;
				width: 2px;
				background: #AEAEAE;
				z-index: 1;
				pointer-events: none;
			}
		`}</style>
		)//`>
	}
	const contentMain = () => {
		if(!showDlg) return (<></>)//>

		const vISparamolarkw1 = (uSelectedArr||[]).filter(vItems=>
			(vItems||"").toString()==="PARAMOLARKW1").length > 0;
		const vISparamolarkw2 = (uSelectedArr||[]).filter(vItems=>
			(vItems||"").toString()==="PARAMOLARKW2").length > 0;
		const vISparamolarkw3 = (uSelectedArr||[]).filter(vItems=>
			(vItems||"").toString()==="PARAMOLARKW3").length > 0;
		const vISparamolarkw4 = (uSelectedArr||[]).filter(vItems=>
			(vItems||"").toString()==="PARAMOLARKW4").length > 0;
		const vISmesiodenatas = (uSelectedArr||[]).filter(vItems=>
			(vItems||"").toString()==="MESIODENATAS").length > 0;
		const vISmesiodenbawah = (uSelectedArr||[]).filter(vItems=>
			(vItems||"").toString()==="MESIODENBAWAH").length > 0;

		//console.log("(MyDialognomorgigi - contentMain) uSelectedArr",uSelectedArr);
		return (
		<div>
			<div className="d-flex justify-content-center align-items-center classborderbottom pb-1 mb-2">
				<CInputGroup className="w-auto" size="sm">
				<CFormSwitch
					value="ALL"
					checked={uSelectedArr.length === uJmlgigiall}
					onChange={()=>onKlikpilih("_ALL_")} 
					id="inpswitchAll"/>
				<label htmlFor="inpswitchAll" className="classcursorpointer classfontsmaller"><small>Semua Gigi</small></label>
				</CInputGroup>

				<CInputGroup className="w-auto ms-3" size="sm">
				<CFormSwitch
					value="MAXILLA"
					checked={(()=>{ 
						if (uSelectedArr.length !== uGigiMaxillaArr.length) return false;

						const sorted1 = [...uSelectedArr].sort(UFunc.customSort);
						const sorted2 = [...uGigiMaxillaArr].sort(UFunc.customSort);

						return sorted1.every((val, index) => val === sorted2[index]);
					})()}
					onChange={()=>onKlikpilih("_MAXILLA_")} 
					id="inpswitchmaxilla"/>
				<label htmlFor="inpswitchmaxilla" className="classcursorpointer classfontsmaller"><small>Regio Maxilla</small></label>
				</CInputGroup>

				<CInputGroup className="w-auto ms-3" size="sm">
				<CFormSwitch
					value="MANDIBULA"
					checked={(()=>{ 
						if (uSelectedArr.length !== uGigiMandibulaArr.length) return false;

						const sorted1 = [...uSelectedArr].sort(UFunc.customSort);
						const sorted2 = [...uGigiMandibulaArr].sort(UFunc.customSort);

						return sorted1.every((val, index) => val === sorted2[index]);
					})()}
					onChange={()=>onKlikpilih("_MANDIBULA_")}
					id="inpswitchmandibula"/>
				<label htmlFor="inpswitchmandibula" className="classcursorpointer classfontsmaller"><small>Regio Mandibula</small></label>
				</CInputGroup>

				<span className="mx-2">&middot;</span>

				<CLink onClick={()=>onKlikpilih("_CLEAR_")} className="classikon classikonreset classcursorpointer"/>
			</div>

			<div className="d-flex justify-content-between my-1">
				<CButton size="sm" color={vISparamolarkw1?"info":"light"} onClick={()=>onKlikpilih("PARAMOLARKW1")} className="border-dark fw-bolder text-uppercase"><small>Paramolar</small></CButton>
				<CButton size="sm" color={vISmesiodenatas?"info":"light"} onClick={()=>onKlikpilih("MESIODENATAS")} className="border-dark fw-bolder text-uppercase"><small>Mesioden</small></CButton>
				<CButton size="sm" color={vISparamolarkw2?"info":"light"} onClick={()=>onKlikpilih("PARAMOLARKW2")} className="border-dark fw-bolder text-uppercase"><small>Paramolar</small></CButton>
			</div>			

			<div className="scroll-horizontal-guard">
				<div className="odontogram-viewport-matrix">
					<div className="jaw-flex-strip">
						<div className="grid-layout columns-16">
						{ADULT_UPPER.map(t => renderTooth(t))}
						</div>
					</div>

					<div className="jaw-flex-strip child-strip-spacing">
						<div className="grid-layout columns-10 child-row-center">
						{CHILD_UPPER.map(t => renderTooth(t))}
						</div>
					</div>

					<div className="center-axis-h"/>

					<div className="jaw-flex-strip child-strip-spacing">
						<div className="grid-layout columns-10 child-row-center">
						{CHILD_LOWER.map(t => renderTooth(t))}
						</div>
					</div>

					<div className="jaw-flex-strip">
						<div className="grid-layout columns-16">
						{ADULT_LOWER.map(t => renderTooth(t))}
						</div>
					</div>
					<div className="center-axis-v" />
				</div>
			</div>

			<div className="d-flex justify-content-between mt-1">
				<CButton size="sm" color={vISparamolarkw4?"info":"light"} onClick={()=>onKlikpilih("PARAMOLARKW4")} className="border-dark fw-bolder text-uppercase"><small>Paramolar</small></CButton>
				<CButton size="sm" color={vISmesiodenbawah?"info":"light"} onClick={()=>onKlikpilih("MESIODENBAWAH")} className="border-dark fw-bolder text-uppercase"><small>Mesioden</small></CButton>
				<CButton size="sm" color={vISparamolarkw3?"info":"light"} onClick={()=>onKlikpilih("PARAMOLARKW3")} className="border-dark fw-bolder text-uppercase"><small>Paramolar</small></CButton>
			</div>
		</div>
		)//>
	}
	//--END CONTENT--/
	
	//--REST_API--/
	//--END REST_API--/

	React.useEffect(()=>{
		return ()=>{}
	},[])
	React.useEffect(()=>{
		//console.log("(MyDialognomorgigi - [showDlg]) showDlg => ",showDlg);
		if(!showDlg) { 
			return;
		}
		setSelectedArr(dataSelectedArr);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},550)
	},[showDlg])
	React.useEffect(()=>{
		if(isUpdated === undefined) return;

		setSelectedArr(dataSelectedArr);
	},[isUpdated])

	//console.log("MyDialognomorgigi - uISDlgviewshow => ",uISDlgviewshow);

	return (
	<>
		<CModal size="xl" alignment="center"
			visible={showDlg}
			fullscreen={uISCellphonemode || uISTabletmode} 
			scrollable
			{...rest}>
		<CModalHeader className="bg-dark text-light py-2"
			closeButton={false}>
			<CModalTitle>
				<div className="d-none d-lg-block">Silahkan Untuk Memilih Nomor Gigi</div>
				<small className="d-lg-none">Pilih Nomor Gigi</small>
			</CModalTitle>
			<CButton color="transparent" className="p-0 m-0 text-white" onClick={toggleShow}>
				<CIcon icon="cilX" height={23}/>
			</CButton>
		</CModalHeader>

		<CModalBody className="d-flex align-items-center d-lg-block">
		{contentMain()}
		</CModalBody>

		<CModalFooter className="px-3 px-lg-5">
			<CButton color="dark" 
				className="d-none d-lg-block" onClick={toggleShow}>
				OK !
			</CButton>
		</CModalFooter>
		</CModal>

		{contentStyling()}
	</>
	)//>
}

export default MyDialognomorgigi;